import { RiderTransportationTypeEnum, RiderVehicleTypeEnum, ServiceTypeEnum } from 'app/models';

export class RiderVehicleType {
    public static RiderVehicleTypeList: Array<any> = [
        { id: RiderVehicleTypeEnum.None, name: 'All' },
        { id: RiderVehicleTypeEnum.Moto, name: 'Moto' },
        { id: RiderVehicleTypeEnum.Sedan, name: 'Sedan' },
        { id: RiderVehicleTypeEnum.SUV, name: 'SUV' },
        { id: RiderVehicleTypeEnum.Fastest, name: 'Fastest' },
        { id: RiderVehicleTypeEnum.PetTaxi, name: 'Pet Taxi' },
        { id: RiderVehicleTypeEnum.Courier, name: 'Courier' },
        { id: RiderVehicleTypeEnum.Cargo, name: 'Cargo' },
        { id: RiderVehicleTypeEnum.Food, name: 'Food' },
        { id: RiderVehicleTypeEnum.Grocery, name: 'Grocery' },
        { id: RiderVehicleTypeEnum.Taxi, name: 'Taxi' },
    ];

    public static RiderVehicleTypeXpressList: Array<any> = [
        { value: RiderVehicleTypeEnum.None, name: 'All' },
        { value: RiderVehicleTypeEnum.Moto, name: 'Moto' },
        { value: RiderVehicleTypeEnum.Sedan, name: 'Sedan' },
        { value: RiderVehicleTypeEnum.SUV, name: 'SUV' },
        { value: RiderVehicleTypeEnum.EVCar, name: 'EV' },
        { value: RiderVehicleTypeEnum.Comfort, name: 'Comfort+' },
        { value: RiderVehicleTypeEnum.Premium, name: 'Premium' }
    ];

    public static RiderVehicleTypeBoracayList: Array<any> = [
        { value: RiderVehicleTypeEnum.None, name: 'All' },
        { value: RiderVehicleTypeEnum.ETrike, name: 'E-Trike' },
        { value: RiderVehicleTypeEnum.Van, name: 'Van' },
        { value: RiderVehicleTypeEnum.Minibus, name: 'Minibus' },
        { value: RiderVehicleTypeEnum.Multicab, name: 'Multicab' }
    ];

    public static RiderVehicleTypeDumagueteList: Array<any> = [
        { value: RiderVehicleTypeEnum.None, name: 'All' },
        { value: RiderVehicleTypeEnum.TrikeSixPax, name: 'Trike Six Pax' },
        { value: RiderVehicleTypeEnum.TrikeFivePax, name: 'Trike Five Pax' }
    ];

    public static RiderVehicleTypeXpressAndBoracayList: Array<any> = [
        { value: RiderVehicleTypeEnum.None, name: 'All' },
        { value: RiderVehicleTypeEnum.Moto, name: 'Moto' },
        { value: RiderVehicleTypeEnum.Sedan, name: 'Sedan' },
        { value: RiderVehicleTypeEnum.SUV, name: 'SUV' },
        { value: RiderVehicleTypeEnum.ETrike, name: 'E-Trike' },
        { value: RiderVehicleTypeEnum.Van, name: 'Van' },
        { value: RiderVehicleTypeEnum.Minibus, name: 'Minibus' },
        { value: RiderVehicleTypeEnum.Multicab, name: 'Multicab' }
    ];

    public static OperatorVehicleTypeList: Array<any> = [
        //{ id: RiderVehicleTypeEnum.Moto, name: 'Moto' },
        { id: RiderVehicleTypeEnum.Sedan, name: 'Sedan' },
        { id: RiderVehicleTypeEnum.SUV, name: 'SUV' }
        //,
        //{ id: RiderVehicleTypeEnum.Fastest, name: 'Fastest' },
        //{ id: RiderVehicleTypeEnum.PetTaxi, name: 'Pet Taxi' },
        //{ id: RiderVehicleTypeEnum.Courier, name: 'Courier' },
        //{ id: RiderVehicleTypeEnum.Cargo, name: 'Cargo' },
        //{ id: RiderVehicleTypeEnum.Food, name: 'Food' },
        //{ id: RiderVehicleTypeEnum.Grocery, name: 'Grocery' },
        //{ id: RiderVehicleTypeEnum.ETrike, name: 'ETrike' },
        //{ id: RiderVehicleTypeEnum.Van, name: 'Van' },
        //{ id: RiderVehicleTypeEnum.Minibus, name: 'Minibus' },
        //{ id: RiderVehicleTypeEnum.Multicab, name: 'Multicab' }
    ];

    public static ServiceAndVehicleTypeXpressList: Array<any> = [
        { id: 1, serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.Moto, isScanAndRide: false, name: 'Ride - Moto' },
        { id: 2, serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.Sedan, isScanAndRide: false, name: 'Ride - Car' },
        { id: 3, serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.SUV, isScanAndRide: false, name: 'Ride - SUV' },
        { id: 4, serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.EVCar, isScanAndRide: false, name: 'Ride - EVCar' },
        { id: 5, serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.Moto, isScanAndRide: true, name: 'S&R - Moto' },
        { id: 6, serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.Sedan, isScanAndRide: true, name: 'S&R - Car' },
        { id: 7, serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.SUV, isScanAndRide: true, name: 'S&R - SUV' },
        { id: 8, serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.EVCar, isScanAndRide: true, name: 'S&R - EVCar' },
        { id: 9, serviceType: ServiceTypeEnum.Delivery, vehicleType: RiderVehicleTypeEnum.Courier, isScanAndRide: false, name: 'Send - Courier' },
        { id: 10, serviceType: ServiceTypeEnum.Delivery, vehicleType: RiderVehicleTypeEnum.Cargo, isScanAndRide: false, name: 'Send - Cargo' },
        { id: 11, serviceType: ServiceTypeEnum.Taxi, vehicleType: RiderVehicleTypeEnum.Taxi, isScanAndRide: false, name: 'Taxi' },
        { id: 12, serviceType: ServiceTypeEnum.Taxi, vehicleType: RiderVehicleTypeEnum.Taxi, isScanAndRide: true, name: 'S&R - Taxi' },
        { id: 13, serviceType: ServiceTypeEnum.Charter, vehicleType: RiderVehicleTypeEnum.TrikeSixPax, isScanAndRide: false, name: 'Charter - Trike Six Pax' },
        { id: 14, serviceType: ServiceTypeEnum.Charter, vehicleType: RiderVehicleTypeEnum.TrikeSixPax, isScanAndRide: true, name: 'S&R - Trike Six Pax' },
        { id: 15, serviceType: ServiceTypeEnum.Charter, vehicleType: RiderVehicleTypeEnum.TrikeFivePax, isScanAndRide: false, name: 'Charter - Trike Five Pax' },
		{ id: 16, serviceType: ServiceTypeEnum.Charter, vehicleType: RiderVehicleTypeEnum.TrikeFivePax, isScanAndRide: true, name: 'S&R - Trike Five Pax' },
		{ id: 17, serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.Comfort, isScanAndRide: false, name: 'Ride - Comfort+' },
		{ id: 18, serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.Comfort, isScanAndRide: true, name: 'S&R - Comfort+' },
		{ id: 19, serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.Premium, isScanAndRide: false, name: 'Ride - Premium' },
		{ id: 20, serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.Premium, isScanAndRide: true, name: 'S&R - Premium' },
    ];

    public static ServiceAndVehicleTypeBoracayList: Array<any> = [
        { id: 1, serviceType: ServiceTypeEnum.Single, vehicleType: RiderVehicleTypeEnum.ETrike, isScanAndRide: false, name: 'Single - E-Trike' },
        { id: 2, serviceType: ServiceTypeEnum.Single, vehicleType: RiderVehicleTypeEnum.Van, isScanAndRide: false, name: 'Single - Van' },
		{ id: 3, serviceType: ServiceTypeEnum.Single, vehicleType: RiderVehicleTypeEnum.Minibus, isScanAndRide: false, name: 'Single - Minibus' },
		{ id: 4, serviceType: ServiceTypeEnum.Single, vehicleType: RiderVehicleTypeEnum.Multicab, isScanAndRide: false, name: 'Single - Multicab' },
        { id: 5, serviceType: ServiceTypeEnum.Charter, vehicleType: RiderVehicleTypeEnum.ETrike, isScanAndRide: false, name: 'Charter - E-Trike' },
        { id: 6, serviceType: ServiceTypeEnum.Charter, vehicleType: RiderVehicleTypeEnum.Van, isScanAndRide: false, name: 'Charter - Van' },
		{ id: 7, serviceType: ServiceTypeEnum.Charter, vehicleType: RiderVehicleTypeEnum.Minibus, isScanAndRide: false, name: 'Charter - Minibus' },
		{ id: 8, serviceType: ServiceTypeEnum.Charter, vehicleType: RiderVehicleTypeEnum.Multicab, isScanAndRide: false, name: 'Charter - Multicab' },
		{ id: 9, serviceType: ServiceTypeEnum.DayTrip, vehicleType: RiderVehicleTypeEnum.ETrike, isScanAndRide: false, name: 'Day Trip - E-Trike' },
		{ id: 10, serviceType: ServiceTypeEnum.DayTrip, vehicleType: RiderVehicleTypeEnum.Multicab, isScanAndRide: false, name: 'Day Trip - Multicab' },
        { id: 11, serviceType: ServiceTypeEnum.Delivery, vehicleType: RiderVehicleTypeEnum.Multicab, isScanAndRide: false, name: 'Send - Multicab' }
    ];

    public static TransportationTypeList: Array<any> = [
        { id: RiderTransportationTypeEnum.Moto, name: '2-Wheeler (Moto)' },
        { id: RiderTransportationTypeEnum.Car, name: '4-Wheeler (Car)' }
    ];
}
